
/* RGT Product Page Badge Injection */
(function(){
  if(!window.location.pathname.startsWith("/products/"))return;
  
  function injectBadges(){
    if(document.querySelector(".rgt-pdp-badges"))return;
    var badges=[];
    
    /* Detect sale */
    var allPrices=document.querySelectorAll("[class*=price]");
    var hasSale=false;
    var currentVal=0,compareVal=0;
    
    allPrices.forEach(function(el){
      var cls=el.className||'';
      var txt=el.textContent.trim().replace(/[^0-9.,]/g,'').replace(',','');
      var val=parseFloat(txt);
      if(isNaN(val))return;
      
      if(cls.indexOf('sale')>-1 || cls.indexOf('Sale')>-1){
        currentVal=val;hasSale=true;
      }
      if(cls.indexOf('compare')>-1 || cls.indexOf('regular')>-1){
        if(el.closest('.price__sale')||el.closest('[class*=compare]')){
          compareVal=val;
        }
      }
    });
    
    if(!hasSale){
      /* Fallback: check if there's a line-through price */
      var dels=document.querySelectorAll('.price del, .price s, [style*=line-through]');
      dels.forEach(function(el){
        var v=parseFloat(el.textContent.replace(/[^0-9.,]/g,'').replace(',',''));
        if(!isNaN(v))compareVal=v;
      });
      var mainPrice=document.querySelector('span.price, .price-item');
      if(mainPrice){
        var v=parseFloat(mainPrice.textContent.replace(/[^0-9.,]/g,'').replace(',',''));
        if(!isNaN(v)&&compareVal>v){currentVal=v;hasSale=true;}
      }
    }
    
    if(hasSale&&compareVal>currentVal&&currentVal>0){
      var pct=Math.round(((compareVal-currentVal)/compareVal)*100);
      badges.push('<span class="rgt-badge rgt-badge--sale">Oferta -'+pct+'%</span>');
    }
    
    /* Detect sold out */
    var addBtn=document.querySelector('button[name="add"]');
    if(addBtn&&addBtn.disabled){
      badges.push('<span class="rgt-badge rgt-badge--sold-out">Agotado</span>');
    }
    
    if(badges.length===0)return;
    
    /* Find title */
    var title=document.querySelector('h1')||document.querySelector('[role="heading"]');
    if(!title)return;
    
    var container=title.closest('[class*="text-block"]')||title.closest('div')||title.parentElement;
    
    var div=document.createElement('div');
    div.className='rgt-pdp-badges';
    div.innerHTML=badges.join('');
    
    /* Insert after the title container */
    if(container&&container.parentNode){
      container.parentNode.insertBefore(div,container.nextSibling);
    }
  }
  
  /* Inject CSS */
  var css=document.createElement('style');
  css.textContent='.rgt-pdp-badges{display:flex;gap:6px;flex-wrap:wrap;margin-top:6px;margin-bottom:4px}.rgt-pdp-badges .rgt-badge{display:inline-flex;align-items:center;font-family:Inter,-apple-system,sans-serif;font-weight:700;font-size:.65rem;letter-spacing:.06em;text-transform:uppercase;padding:4px 14px;border-radius:999px;background:transparent;line-height:1.3}.rgt-badge--sale{color:#C5A059;border:1.5px solid #C5A059}.rgt-badge--sold-out{color:#86868b;border:1.5px solid #aeaeb2}.rgt-badge--new{color:#34C759;border:1.5px solid #34C759}';
  document.head.appendChild(css);
  
  /* Run with delay to ensure page is rendered */
  setTimeout(injectBadges,800);
  setTimeout(injectBadges,2000);
})();
